import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ca2b5046&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ca2b5046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2b5046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca2b5046')) {
      api.createRecord('ca2b5046', component.options)
    } else {
      api.reload('ca2b5046', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ca2b5046&scoped=true&", function () {
      api.rerender('ca2b5046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wDeASB2jwI5H/JS/comp/PopupBox.vue"
export default component.exports